import http from './http'

const saveXML = (cadastro) =>  http.post('saveXML', { cadastro })
export default saveXML